<template>
	<div class="v--preloader" :class="{'m--absolute': absolute, 'm--overlay': overlay}">
		<div class="v--preloader__wrapper"><div class="v--preloader__wheel"></div></div>
	</div>
</template>

<script>
export default {

	props: {
		absolute: {
			type: Boolean,
			default: () => true,
		},
		overlay: {
			type: Boolean,
			default: () => true,
		},
	},

}
</script>

<style scoped lang="scss">

</style>
